<template>
	<div>

		<div :class="{ 'hidden': reviewsStore.show.review_box }" class="IW floatingArea">
			<div style="display: flex; flex-direction: column;">
				<div class="mini-buttons" style="display: flex; justify-content: flex-end;">
					<div class="toggle-arrow" @click="reviewsStore.show.review_box = !reviewsStore.show.review_box">
						{{ reviewsStore.show.review_box ? '‹' : '›' }}
					</div>
				</div>
				<!-- Floating Review Box -->
				<div v-if=" !reviewsStore.show.review_box" v-show="reviewsStore.reviews.total > 0" class="review-box mt-4" itemscope itemtype="https://schema.org/Organization" @click="isModalActive = true">
					<div class="has-text-centered" itemprop="name" role="heading">Immobilienwerker</div>
					<div class="rating-container" itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating">
			<span itemprop="itemReviewed" itemscope itemtype="https://schema.org/Organization">
				<meta content="Immobilienwerker LTD" itemprop="name">
			</span>
						<span class="rating" itemprop="ratingValue">{{ reviewsStore.averageRating.toFixed(2).replace('.', ',') }} / 5</span>
						<div class="stars">
							<span class="rating-text has-text-weight-bold">{{ reviewsStore.ratingText }}</span>
							<rate-component :value="reviewsStore.averageRating" disabled></rate-component>
						</div>
						<span class="total-reviews">
								<span itemprop="ratingCount">{{ reviewsStore.reviews.total }}</span> Bewertungen
							</span>
						<meta content="5" itemprop="bestRating">
						<meta content="1" itemprop="worstRating">
					</div>
				</div>
				<div v-if="!reviewsStore.show.review_box" class="review-box mt-4 has-text-centered" @click="openCalModal">
					Rückruf vereinbaren
				</div>
			</div>
		</div>

		<button_rueckruf ref="buttonRueckruf" :hide_button="true"/>

		<b-modal :active="isModalActive" :width="640" has-modal-card scroll="keep" @close="isModalActive = false">
			<div class="modal-card" style="width: auto">
				<header class="modal-card-head">
					<p class="modal-card-title">
						Echte Bewertungen
						<span class="is-hidden-mobile">für
						<mark>Immobilienwerker</mark>
							</span>
					</p>
				</header>
				<section class="modal-card-body has-background-white is-paddingless">
					<review-summary class="p-4" style="border-bottom: 1px solid lightgray;"/>

					<div class="reviews-list p-4" style="background: #F9F9F9;">
						<reviews-item v-for="review in reviewsWithText" :key="`R${review.id}`" :review="review" :show_plattform="false"/>
						<div v-if="this.reviewsStore.reviews.next_page_url" class="has-text-centered mb-4">
							<b-button :loading="isLoadingMore" @click="fetchDataAndScroll">Mehr laden</b-button>
						</div>
					</div>
				</section>
			</div>
		</b-modal>
	</div>
</template>
<script setup>
import {useReviewsStore} from "@/store/reviews";

const reviewsStore = useReviewsStore()
// eslint-disable-next-line no-undef
defineExpose({reviewsStore})

</script>
<script>
import ReviewsItem from "@/components/reviews/components/reviewItem.vue";
import ReviewSummary from "@/components/reviews/Summary.vue";

export default {
	name: 'ReviewBox',
	components: {ReviewSummary, ReviewsItem},
	data() {
		return {
			isModalActive: false,
			visibleReviews: [],
			page: 1,
			perPage: 10,
			isLoadingMore: false,
		}
	},
	mounted() {
		this.initReviews();
	},
	computed: {
		reviewsWithText() {
			return this.reviewsStore.reviews.items.filter(review => review.description);
		},
	},
	methods: {
		openCalModal() {
			this.$refs.buttonRueckruf.openModal();
		},
		async initReviews() {
			if (this.reviewsStore.shouldFetchReviews) {
				await this.reviewsStore.fetchReviews();
			}
			// this.reviewsStore.loadMoreReviews();
		},
		fetchDataAndScroll() {
			this.reviewsStore.fetchReviews()
				.then(() => {
					this.$nextTick(() => {
						const reviewsList = document.querySelector('.reviews-list');
						if (reviewsList) {
							setTimeout(() => {
								reviewsList.scrollBy({
									top: 250,
									behavior: 'smooth',
								});
							}, 50); // Timeout von 500ms
						}
					});
				})
		},
	},

	beforeMount() {
	},
}
</script>

<style scoped>
@media only screen and (max-width: 767px) {
	.floatingArea {
		position: fixed;
		bottom: 20px;
		top: auto;
		right: 10px;
		transform: none;
		z-index: 2;
		/* Kleiner auf MObile*/
		padding: 10px;
	}
}

@media (min-width: 769px) {
	.floatingArea {
		position: fixed;
		top: 50%;
		right: 10px;
		transform: translateY(-50%);
		z-index: 2;
		/* falls notwendig */
		display: block;

	}
}

.floatingArea.hidden {
	width: auto;
	height: auto;
}

.toggle-arrow {
	font-size: 2rem;
	background-color: white;
	border-radius: 6px;
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mini-buttons .toggle-arrow {
	margin-left: 10px;
}

.toggle-arrow i {
	font-size: 14px;
	color: #363636;
}

.floatingArea.hidden .toggle-arrow {
	position: static;
}

.review-box {
	background: white;
	border-radius: 8px;
	padding: 15px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	cursor: pointer;
	transition: transform 0.2s;
}

.review-box:hover {
	transform: scale(1.02); /* Behalte translateY(-50%) bei */
}

.visually-hidden {
	position: absolute;
	left: -9999px;
}

.rating-container {
	text-align: center;
}

.rating {
	font-size: 24px;
	font-weight: bold;
	color: #363636;
}

.stars {
	margin: 8px 0;
}

.total-reviews {
	font-size: 14px;
	color: #666;
}

.rating-bar-item .b-progress {
	flex-grow: 1;
}

.reviews-list {
	max-height: 400px;
	overflow-y: auto;
}

.review-item {
	padding: 15px 0;
	border-bottom: 1px solid #eee;
}

.review-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.review-date {
	color: #666;
	font-size: 0.9em;
}

.review-author {
	font-weight: bold;
	margin: 5px 0;
}

.review-text {
	color: #363636;
}

.rating-text {
	display: block;
	font-size: 14px;
	color: #666;
	margin: 4px 0;
}

.progress-wrapper {
	margin-bottom: 0px;
}

.card-content {
	border: 1px solid lightgray;
}

.card {
	margin-bottom: 1rem;
}

.card .media:not(:last-child) {
	margin-bottom: .5rem;
}

.reviews-list {
	max-height: 400px;
	overflow-y: auto;
}
</style>
